"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const ModalHeading_1 = __importDefault(require("./ModalHeading"));
exports.default = ModalHeading_1.default;
